
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { BasicScenario, Role, RoleCriteria, RoleWrapper } from '@wizeoo/akm-message-lib';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';
import { ViewData } from '../../../model/view.data';
import { RoleVO } from '../../../vo/user/role.vo';

/**
 * Appels role (Find)
 */
export class RoleCmd extends WizCommand<RoleWrapper> {

  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  // mémorisation de la source pour mise à jour sur retour service
  public sourceVO: RoleVO = null;

  /** retourne le wrapper pré-alimenté */
  public RoleWrapper(): RoleWrapper {
    const wrapper: RoleWrapper = new RoleWrapper();
    wrapper.criteria = new RoleCriteria();
    wrapper.criteria.manageDeprecated = true;
    wrapper.criteria.manageDeleted = true;
    // wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.criteria.domain = this.model.currentDomainCode || this.model.domainCode;
    wrapper.scenario = new BasicScenario();
    wrapper.scenario.languageCode = this.model.localeEngine.getLocale();
    return wrapper;
  }


  /**
   * chargement de tous les roles du domaine
   * @return RoleCmd la commande configuré
   */
  public find(): RoleCmd {
    const wrapper: RoleWrapper = this.RoleWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.ROLE_API, wrapper);
    return this;
  }

  /**
   * chargement de tous les roles du domaine
   * @return RoleCmd la commande configuré
   */
  public findWildcard(): RoleCmd {
    const wrapper: RoleWrapper = this.RoleWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria.domain = ViewData.wildcardDomain;
    wrapper.criteria.businessUnitCode = ViewData.wildcardDomain;
    this.configureRemote(ExternalAPI.ROLE_API, wrapper);
    return this;
  }

  /**
   * retour de service
   * gestion de retour selon la méthode d'appelle
   */
  public wizResult(): void {
    super.wizResult();
    const wrapper: RoleWrapper = this.result;
    
    
    if (!this.model.rolesMap) {
      this.model.rolesMap = new Map(); // map de roles pour AKM
      this.model.rolesFastMap = new Map(); // map pour DOM
    }
    
    if(!!wrapper) {
      // convertion de la liste de retour en liste de RoleVO
      let roles: RoleVO[] = wrapper.entities.map((element: Role) => new RoleVO(this.model, element));

      // construction des maps
      const roleMap = this.model.rolesMap;
      const roleFastMap = this.model.rolesFastMap;
      let fastKey: string;

      roles.forEach((r: RoleVO) => {
        
        // alimentation de la map AKM
        if (!roleMap.has(r.businessUnitCode)) {
          roleMap.set(r.businessUnitCode,new Map());
        }
        if (!roleMap.get(r.businessUnitCode).has(r.visionCode)) {
          roleMap.get(r.businessUnitCode).set(r.visionCode,new Map());
        }
        roleMap.get(r.businessUnitCode).get(r.visionCode).set(r.code, r);

        fastKey = this.model.roleEngine.getRoleKey(r);
        roleFastMap.set(fastKey, r);

      });
    }
  }
}
